module.exports = {
  REPATRIATIONS_TRANSACTIONS_OBJECT_REQUEST: 'REPATRIATIONS_TRANSACTIONS_OBJECT_REQUEST',
  REPATRIATIONS_TRANSACTIONS_OBJECT_SUCCESS: 'REPATRIATIONS_TRANSACTIONS_OBJECT_SUCCESS',
  REPATRIATIONS_TRANSACTIONS_OBJECT_FAILURE: 'REPATRIATIONS_TRANSACTIONS_OBJECT_FAILURE',
};
